import { setInQuerySingle } from '@front-app/util/routing';
import { computed, Ref } from '@vue/composition-api';
import VueRouter, { Location, Route } from 'vue-router';

export interface UseRouteQueryArray {
	append(val: string): Ref<Location>;
	appendVisit(val: string): void;
	remove(val: string): Ref<Location>;
	removeVisit(val: string): void;
	clear(): Ref<Location>;
	clearVisit(): void;
}

export function useRouteQueryArray(router: VueRouter, currentRoute: Ref<Route>, key: string, values: Ref<string[]>): UseRouteQueryArray {
	const append = (val: string) => computed(() => setInQuerySingle(router, currentRoute.value, key, [...values.value, val]));
	const remove = (val: string) => computed(() => setInQuerySingle(router, currentRoute.value, key, values.value.filter((_) => _ !== val)));
	const clear = () => computed(() => setInQuerySingle(router, currentRoute.value, key, []));
	const appendVisit = (val: string) => {
		router.push(append(val).value);
	};
	const removeVisit = (val: string) => {
		router.push(remove(val).value);
	};
	const clearVisit = () => {
		router.push(clear().value);
	};
	return {
		append,
		appendVisit,
		remove,
		removeVisit,
		clear,
		clearVisit,
	};
}
